import api from "./api";

export async function toggleNoteBookmark(payload = {}) {
  const response = await api.post("/notes/bookmark", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function toggleNoteLike(payload = {}) {
  const response = await api.post("/notes/like", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function createNoteReport(payload = {}) {
  const response = await api.post("/notes/report", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchNoteReports(params = {}) {
  const response = await api.get("/notes/reports", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function deleteNoteReport(payload = {}) {
  const response = await api.delete("/notes/report-delete", {
    data: payload,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function createPersonalNote(payload = {}) {
  const response = await api.post("/notes/notes", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchPersonalNotes(params = {}) {
  const response = await api.get("/notes/user-notes", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function deletePersonalNote(payload = {}) {
  const response = await api.delete("/notes/note-delete", {
    data: payload,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchNoteViewActivity(params = {}) {
  const response = await api.get("/notes/view", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function storeNoteTime(payload = {}) {
  const response = await api.post("/notes/store-time", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function toggleNoteReadStatus(payload = {}) {
  const response = await api.post("/notes/mark-read", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
